import {ICache} from "~/interfaces/cacheInterfaces"
import Cache from "../../utils/cache"

export default class Revive<T extends object> {
  private _cache: ICache<T> = new Cache<T>()

  protected cached<K extends keyof T>(key: K, callback: () => T[K]): T[K] {
    return this._cache.cached(key, callback)
  }
}